// src/pages/configuracion/ConfiguracionPage.tsx
import { Outlet, NavLink, useLocation, Navigate } from 'react-router-dom';
import { Card } from '@/components/ui';
import { User, Settings, Users, Shield, Database, Zap } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { cn } from '@/lib/utils';

const MENU_ITEMS = [
  { path: '/configuracion/perfil', label: 'Mi Perfil', icon: User },
  { path: '/configuracion/preferencias', label: 'Preferencias', icon: Settings },
];

const ADMIN_ITEMS = [
  { path: '/configuracion/usuarios', label: 'Usuarios', icon: Users },
  { path: '/configuracion/roles', label: 'Roles', icon: Shield },
  { path: '/configuracion/sistema', label: 'Sistema', icon: Database },
  { path: '/configuracion/automatizaciones', label: 'Automatizaciones', icon: Zap },
];

export function ConfiguracionPage() {
  const location = useLocation();
  const { user } = useAuthStore();
  const isAdmin = user?.roles?.includes('ADMIN');

  const menuItems = isAdmin ? [...MENU_ITEMS, ...ADMIN_ITEMS] : MENU_ITEMS;

  // Redirect to perfil if on /configuracion
  if (location.pathname === '/configuracion') {
    return <Navigate to="/configuracion/perfil" replace />;
  }

  return (
    <div className="flex gap-6 h-full">
      {/* Sidebar de navegacion */}
      <Card className="w-64 p-4 h-fit shrink-0">
        <h2 className="font-semibold mb-4 text-gray-900">Configuracion</h2>
        <nav className="space-y-1">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors',
                  isActive
                    ? 'bg-blue-50 text-blue-700 font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </Card>

      {/* Contenido */}
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
